export default {
  data() {
    return {
      requiredRule: value => !!value || this.$t('form.error.required'),
    }
  }
}